<template>
  <TabsLayout>
    <ElTabPane name="designer" label="3D设计人员"></ElTabPane>
    <ElTabPane name="designeravgdata" label="3D设计人均数据"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  name: 'designerkpi',
  components: { TabsLayout }
}
</script>
